export default __webpack_public_path__ + "static/media/home2S.d776be09.webp";